export const changeOrientation = orientation => ({
  type: 'WINDOW::ORIENTATION::CHANGE',
  orientation
})
export const changeFullscreen = fullscreen => ({
  type: 'WINDOW::FULLSCREEN::CHANGE',
  fullscreen
})
export const changePopoutMode = popoutMode => ({
  type: 'WINDOW::POPOUT_MODE::CHANGE',
  popoutMode
})

export const reflow = data => {
  return dispatch => {
    console.log('Calling reflow action with data:', data)
    window.top.postMessage(
      {
        liveApp: {
          action: 'reflow',
          data
        }
      },
      '*'
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/window.js